import { GuideState } from './common/guide-state.constants';

export class GuideResume {

    private _id: number;
    private _username: string;
    private _email: string;
    private _companyName: string;
    private _country: string;
    private _city: string;
    private _phone: string;
    private _state: GuideState;

    constructor(
      id: number,
      username: string,
      email: string,
      companyName: string,
      country: string,
      city: string,
      phone: string,
      state: GuideState

    ) {

        this._id = id;
        this._username = username;
        this._email = email;
        this._companyName = companyName;
        this._country = country;
        this._city = city;
        this._phone = phone;
        this._state = state;

    }


    get id(): number {
        return this._id;
    }

    get username(): string {
        return this._username;
    }

    get email(): string {
        return this._email;
    }

    get companyName(): string {
        return this._companyName;
    }

    get country(): string {
        return this._country;
    }

    get city(): string {
        return this._city;
    }

    get phone(): string {
        return this._phone;
    }

    get state(): GuideState {
        return this._state;
    }

}
